import React from "react";
import {inject, observer} from "mobx-react";
import {computed} from "mobx";
import {tableSchema} from "@schemas/Admin";
import StoreDataScreen from "@containers/Admin/StoreDataScreen";
import {SubDataTable} from "@containers/Admin/StoreDataTable";

const dataScreen = (data) => (Component) =>{
    return ()=><Component {...data}/>
};

@inject("adminStudentStore")
@observer
class StudentSessions extends React.Component{

    componentDidMount(): void {
        const {adminStudentStore} = this.props;
        if (!adminStudentStore.loaded && !adminStudentStore.loading) {
            adminStudentStore.load();
        }
    }

    @computed
    get _student() {
        const {adminStudentStore, match} = this.props;
        const id = ~~match.params.id;
        const student = adminStudentStore.data.find(c => c.id === id);

        return student || null;
    }

    @computed
    get Component(){
        return dataScreen({schema:tableSchema.session,data:this._student.sessions,baseRoute:"sessions"})(SubDataTable);
    }

    render(){
        // const Component = dataScreen({schema:tableSchema.student,data:this._cp.students,baseRoute:"students"})(SubDataTable);
        return <this.Component/>;
    }
}

export default StudentSessions;
